var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "company-account"
  }, _vm._l((_vm.accountList), function(item, index) {
    return _c('trans-account-row', {
      key: item.bank_account,
      attrs: {
        "item": item,
        "last": index == _vm.accountList.length - 1
      }
    })
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-760db59c","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/TransAccounts.vue
// module id = 245
// module chunks = 0